import axios from "axios";

const store = {
  state: {
    good_type: [],
  },
  getters: {
    getDeliveryTypeGoodType: (state) => (delivery_type) => {
      let good_type = [];

      state.good_type.map((type, index) => {
        if (type.delivery_types.includes(delivery_type)) {
          good_type.push(type);
        }
      });

      return good_type;
    },
  },
  mutations: {
    INITIALIZE_GOOD_TYPE(state, payload) {
      state.good_type = payload;
    },
  },
  actions: {
    initializeGoodType({ commit, state }, param) {
      return axios
        .get(this._vm.$endpoints.customer_good_type, {
          params: param,
        })
        .then((res) => {
          let response = res.data.data;
          commit("INITIALIZE_GOOD_TYPE", response);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

export default store;
